import { _DEBUG } from './constants';

/**
 * Fetches product detail data (e.g. tier prices, apoCash) from the backend.
 * The backend handles shop-specific features gracefully (e.g. apoCash).
 *
 * @param {number|string} productId  - The product ID
 * @param {number|string} amount     - The requested quantity
 * @param {AbortSignal} signal       - Optional AbortSignal to cancel the request
 * @returns {Promise<Object>}        - Promise that resolves with the parsed JSON result
 */
export async function fetchProductDetail(productId, amount, signal) {
  if (_DEBUG) console.log('Fetching:', productId, amount);

  try {
    const params = new URLSearchParams({ action: 'fetch-product-detail', id: productId, amnt: amount });
    const response = await fetch(`/rpc.php?${params}`, { method: 'GET', signal });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    return await response.json();
  } catch (error) {
    if (error.name !== 'AbortError') console.error('fetchProductDetail failed:', error);
    throw error;
  }
}
